import React, { useState, useEffect } from 'react';

import { Pagination as PaginationLib } from '@material-ui/lab';

import { Container } from './styles';

export type PaginationProps = {
  total: number;
  showPageLimit?: boolean;
  onChange: (pageValue: number, limit: number) => void;
  resetPage?: boolean;
  onReset: (reseted: boolean) => void;
};

const Pagination: React.FC<PaginationProps> = ({
  total,
  onChange,
  resetPage,
  onReset,
}): JSX.Element => {
  const [limit, setLimit] = useState<number>(15);
  const [page, setPage] = useState<number>(1);
  const pages = Math.ceil(total / limit);

  const handleChangePage = (
    e: React.ChangeEvent<unknown>,
    pageValue: number,
    limit: number,
  ): void => {
    e.preventDefault();
    setPage(pageValue);
    onChange(pageValue, limit);
  };

  useEffect(() => {
    if (resetPage) {
      setPage(1);
      setLimit(15);
      onReset(false);
    }
  }, [onReset, resetPage]);

  return (
    <Container>
      <PaginationLib
        count={pages}
        color="primary"
        variant="text"
        defaultPage={1}
        page={page}
        onChange={(event: React.ChangeEvent<unknown>, page) =>
          handleChangePage(event, page, limit)
        }
      />
    </Container>
  );
};

export default Pagination;
